import type { ReactNode } from "react";
import { useWorkspaceState, WorkspaceContext } from "@/hooks/use-workspace";

export function WorkspaceProvider({ children }: { children: ReactNode }) {
  const value = useWorkspaceState();
  return <WorkspaceContext.Provider value={value}>{children}</WorkspaceContext.Provider>;
}
